import CryptoJS from 'crypto-js'

import { StringForGenerateToken } from 'shared/constants'

const generateRandomString = (length = 64) => {
  let result = ''
  const charactersLength = StringForGenerateToken.length

  for (let i = 0; i < length; i++) {
    result += StringForGenerateToken.charAt(
      Math.floor(Math.random() * charactersLength),
    )
  }

  return result
}

const getModifyToken = (Key: string) => {
  const KeyPart1 = Key.slice(0, 32)
  const KeyPart2 = Key.slice(32, 64)

  const Ords = []

  for (let i = 0; i < KeyPart1.length; i++) {
    const CharOrd = KeyPart1.charCodeAt(i) + KeyPart2.charCodeAt(i)
    Ords.push(CharOrd)
  }

  const KeyAVG = Ords.reduce((a, b) => a + b, 0) / Ords.length

  const KeySub =
    KeyPart1.charCodeAt(0) * 2 +
    KeyPart1.charCodeAt(31) +
    KeyPart2.charCodeAt(31)
  const HexedOrd = []

  for (let i = 0; i < Ords.length; i++) {
    let temp = Ords[i]
    for (let j = 1; j < 11; j++) {
      temp *= j
    }
    HexedOrd.push(temp.toString(16) + KeyAVG + KeySub)
  }

  const combinedString = HexedOrd.join('')

  return CryptoJS.MD5(combinedString).toString()
}

export const getGeneratedToken = () => {
  const generatedToken = generateRandomString()

  const modifiedToken = getModifyToken(generatedToken)

  return {
    generatedToken,
    modifiedToken,
  }
}
